import type { DeepReadonly } from 'vue'
import { DeckMode, type Deck } from '~~/entities/deck'

export function useDeckMode(deck: DeepReadonly<Ref<Deck | null>>) {
  const currentMode = ref<DeckMode>(DeckMode.LoadingMode)
  const { state: userState } = useUser()
  const { currentMeeting } = useMeetings()

  const hasEditPermissions = computed(() => {
    const perm = deck.value?.permissions
    return !!userState.value?.flags?.WORLD_BUILDER && !!perm && perm.update && perm.create && perm.destroy
  })

  function evaluateDeckMode(meId: number | undefined) {
    if (currentMeeting.value?.ended_at === null) {
      const uid = userState.value.user?.id
      const isHost = uid != null && meId === uid && currentMeeting.value?.host_id === uid
      currentMode.value = isHost ? DeckMode.PresentationMode : DeckMode.ParticipantMode
      return
    }

    if (!hasEditPermissions.value) {
      currentMode.value = DeckMode.PresentationMode
      return
    }

    currentMode.value = DeckMode.EditMode
  }

  function updateMode(mode: DeckMode) {
    currentMode.value = mode
  }

  return { currentMode, hasEditPermissions, updateMode, evaluateDeckMode }
}
